/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_LabelInputs */

const en_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Detection Mode`)
};

const fr_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode de détection de texte`)
};

const de_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texterkennungsmodus`)
};

const it_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità di rilevamento del testo`)
};

const ru_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим распознавания текста`)
};

const es_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de detección de texto`)
};

const zh_cn2_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本检测模式`)
};

const ja_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト検出モード`)
};

const hi_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट डिटेक्शन मोड`)
};

const pt_pt2_ocr_psm_label = /** @type {(inputs: Ocr_Psm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de detecção de texto`)
};

/**
* | output |
* | --- |
* | "Text Detection Mode" |
*
* @param {Ocr_Psm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_label = /** @type {((inputs?: Ocr_Psm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_psm_label(inputs)
	if (locale === "de") return de_ocr_psm_label(inputs)
	if (locale === "it") return it_ocr_psm_label(inputs)
	if (locale === "ru") return ru_ocr_psm_label(inputs)
	if (locale === "es") return es_ocr_psm_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_psm_label(inputs)
	if (locale === "ja") return ja_ocr_psm_label(inputs)
	if (locale === "hi") return hi_ocr_psm_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_psm_label(inputs)
	return en_ocr_psm_label(inputs)
});